module.exports = __webpack_public_path__ + "img/img20.fca61ada.png";